<template>
  <div class="liucheng">
    <div class="left">
      <div class="quan"><img src="../assets/images/quan.png" alt="" /></div>
      <div class="xian xian1"></div>
      <div class="quan"><img src="../assets/images/quan.png" alt="" /></div>
      <div class="xian xian2"></div>
      <div class="quan"><img src="../assets/images/quan.png" alt="" /></div>
    </div>
    <div class="neirong">
      <div class="first">
        <div class="title">
          <div class="word">读取卡号</div>
        </div>
        <div class="content">
          <div class="incontent">
            <img src="../assets/images/NFCone.png" alt="" />
          </div>
        </div>
      </div>
      <div class="second">
        <div class="title">
          <div class="word">选择金额,完成支付</div>
        </div>
        <div class="content">
          <div class="head">充值金额</div>
          <div class="list1">
            <div class="inlist firstInlist">10元</div>
            <div class="inlist">50元</div>
            <div class="inlist">100元</div>
          </div>
          <div class="list2">
            <div class="inlist">200元</div>
            <div class="inlist">500元</div>
            <div class="inlist">其他金额</div>
          </div>
        </div>
      </div>
      <div class="third">
        <div class="title">
          <div class="word">支付完成后，请再次读取卡片完成充值</div>
        </div>
        <div class="content">
          <div class="incontent">
            <div class="phone">
              <img src="../assets/images/NFCsuccess.png" alt="" />
            </div>
            <div class="card">
              <img src="../assets/images/NFCka.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
export default {
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.liucheng {
  display: flex;
  padding: 3.625rem 1.25rem 3.875rem 2.375rem;
 
  background: linear-gradient(180deg, #ffffff 0%, #eef4f6 9.76%);
  min-height: 100vh;

  .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    .quan {
      img {
        width: 2.5rem;
      }
    }
    .xian {
      width: 0.375rem;
      height: 27.5rem;
      background: #338989;
    }
    .xian2 {
      height: 27.5rem;
    }
  }
  .neirong {
    margin-left: 1.25rem;
    flex-grow: 1;
    .first {
      .title {
        .word {
          color: #19212a;
          font-size: 1.875rem;
          line-height: 2.75rem;
          font-weight: 400;
        }
      }
      .content {
        .incontent {
          display: flex;
          justify-content: center;
          margin-top: 2.125rem;
          img {
            width: 20.375rem;
            height: 23rem;
          }
        }
      }
    }
    .second {
      margin-top: 2.375rem;
      .title {
        .word {
          color: #19212a;
          font-size: 1.875rem;
          line-height: 2.75rem;
            font-weight: 400;
        }
      }
      .content {
        margin-top: 1.5rem;
        background-color: #fff;
        padding: 2.375rem 2.25rem 2.25rem 2.25rem;
        border-radius: 1rem;
        .head {
          color: #19212a;
          font-size: 1.625rem;
        }
        .list1 {
          display: flex;
          justify-content: space-between;
          margin-top: 1.875rem;
          .inlist {
            width: 10.375rem;
            height: 6rem;
  text-align: center;
            line-height: 6rem;
            border: 1px solid #eee;
            border-radius: 1rem;
            font-size: 1.625rem;
            white-space: nowrap;
          }
          .firstInlist {
            background: rgba(190, 255, 255, 0.3);
          }
        }
        .list2 {
          display: flex;
          justify-content: space-between;
          margin-top: 1.875rem;
          .inlist {
            border: 1px solid #eee;
            border-radius: 1rem;
            font-size: 1.625rem;
            width: 10.375rem;
            height: 6rem;
            text-align: center;
            line-height: 6rem;
          }
        }
      }
    }
    .third {
      margin-top: 3.5rem;
      .title {
        .word {
          color: #19212a;
          font-size: 1.875rem;
          line-height: 2.75rem;
            font-weight: 400;
        }
      }
      .content {
        .incontent {
          display: flex;
          justify-content: center;
          .phone {
            margin-top: 4.125rem;
            margin-right: -5.375rem;
            z-index: 100;
            img {
              width: 12.875rem;
              height: 24rem;
            }
          }
          .card {
            margin-top: 3.125rem;

            img {
              width: 11.375rem;
            }
          }
        }
      }
    }
  }
}
</style>